<div *ngIf="isLoading">Loading Expenditure List...</div>

<select *ngIf="!isLoading" [compareWith]="byId" class="form-control" name="expenditure" [(ngModel)]="model.expenditure" [required]="required">
  <option *ngFor="let singleExpenditure of expenditures" [ngValue]="singleExpenditure">{{ singleExpenditure.name }}</option>
</select>
